import { DateTime } from 'luxon'

type MemberOrUser = {
  name?: string | null
  firstName?: string | null
  lastName?: string | null
  uuid?: string
  id?: number
}

export const getFullName = ({
  name,
  firstName,
  lastName,
  id,
  uuid,
}: MemberOrUser): string => {
  if (name) return name
  if (firstName && lastName) return `${firstName} ${lastName}`

  return `Member ${id ?? uuid}`
}

export const calculateAge = (birthDate: DateTime): number => {
  const today = DateTime.local()
  let age = today.year - birthDate.year

  // Subtract 1 if birthday hasn't happened yet this year
  if (
    today.month < birthDate.month ||
    (today.month === birthDate.month && today.day < birthDate.day)
  ) {
    age--
  }

  return age
}
